import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-badge",
    styleUrl: "badge.scss",
    shadow: true
})
export class Badge {
    render() {
        return (
            <Host role="status">
                <slot />
            </Host>
        );
    }
}
